"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const ecommerce_1 = require("../../api/ecommerce");
const array_1 = require("../../common/js/helper/array");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
const Paths_1 = require("../constants/Paths");
const path_1 = require("../helper/path");
const payment_1 = require("../helper/payment");
const ShopwareCart_1 = __importDefault(require("./ShopwareCart"));
const ShopwareContext_1 = __importDefault(require("./ShopwareContext"));
const ShopwarePaymentMethods_1 = __importDefault(require("./ShopwarePaymentMethods"));
class ShopwareOrder {
    api = new ecommerce_1.OrderApi(configuration_1.default);
    orders = new Map();
    loading = false;
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            orders: mobx_1.observable,
            loading: mobx_1.observable,
            isLoading: mobx_1.computed,
            ordersFromCompany: mobx_1.computed,
            loadOrdersForCompany: mobx_1.action.bound,
            setPayment: mobx_1.action.bound,
        });
    }
    get isLoading() {
        return this.loading;
    }
    get ordersFromCompany() {
        return Array.from(this.orders.values()).sort((a, b) => (b.orderDateTime.getTime() ?? 0) - (a.orderDateTime.getTime() ?? 0));
    }
    loadOrder(id) {
        return this.api
            .readOrders({
            ids: id,
            associations: {
                addresses: {
                    associations: {
                        country: { ' ': 1 },
                    },
                },
                currency: { ' ': 1 },
                orderCustomer: { ' ': 1 },
                lineItems: { ' ': 1 },
                transactions: {
                    associations: {
                        paymentMethod: { ' ': 1 },
                        stateMachineState: { ' ': 1 },
                    },
                },
            },
        })
            .then((ordersResponse) => (0, array_1.first)(ordersResponse.orders?.elements ?? []) ?? null);
    }
    createOrder(customerComment) {
        return this.api.createOrder({ createOrderRequestBody: { customerComment } }).then((createdOrder) => {
            const order = createdOrder;
            if (!order) {
                return Promise.reject();
            }
            const orderId = order.id;
            if (!orderId) {
                return Promise.reject();
            }
            return ShopwarePaymentMethods_1.default.isAdyenPaymentMethod((0, payment_1.getOrderPaymentMethodId)(order))
                .then((isAdyenPayment) => ({
                isAdyenPayment,
                order,
                orderId,
            }))
                .finally(() => ShopwareCart_1.default.loadCart())
                .finally(() => ShopwareContext_1.default.loadContext());
        });
    }
    handlePayment(orderId, stateData) {
        const errorUrl = `${window.location.origin}${(0, path_1.localePath)(Paths_1.PATH_SHOP_CHECKOUT_PAY_ERROR).replace(':orderId', orderId)}`;
        const finishUrl = `${window.location.origin}${(0, path_1.localePath)(Paths_1.PATH_SHOP_CHECKOUT_CONFIRMATION).replace(':orderId', orderId)}`;
        return this.api
            .handleOrderPayment({
            handlePaymentRequestBody: {
                errorUrl,
                finishUrl,
                orderId: orderId,
                stateData,
            },
        })
            .then((handlePaymentResponse) => {
            const redirectUrl = handlePaymentResponse?.redirectUrl;
            if (!redirectUrl) {
                return Promise.reject();
            }
            if (redirectUrl === errorUrl || redirectUrl.startsWith(errorUrl + '?')) {
                window.location.replace(redirectUrl);
                return Promise.reject();
            }
            return redirectUrl;
        });
    }
    loadOrdersForCompany() {
        this.orders.clear();
        this.loading = true;
        return this.api
            .readOrdersForCompany()
            .then((orders) => {
            orders.forEach((order) => {
                this.orders.set(order.id, order);
            });
            return this.orders;
        })
            .finally((0, mobx_1.action)(() => {
            this.loading = false;
        }));
    }
    setPayment(orderId, paymentMethodId) {
        this.loading = true;
        return this.api
            .setPayment({
            orderSetPaymentMethod: {
                paymentMethodId,
                orderId,
            },
        })
            .then((success) => {
            if (!success?.success) {
                return Promise.reject();
            }
        })
            .finally((0, mobx_1.action)(() => {
            this.loading = false;
        }));
    }
}
__decorate([
    bind_decorator_1.default
], ShopwareOrder.prototype, "loadOrder", null);
__decorate([
    bind_decorator_1.default
], ShopwareOrder.prototype, "createOrder", null);
exports.default = new ShopwareOrder();
